import * as React from "react";

function SvgImagingHistory(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5765 0H8.42355C7.90215 0 7.48239 0.409024 7.48239 0.917086V2.49234H2.21857C0.989527 2.49234 0 3.45601 0 4.6536V16.8382C0 17.706 0.519598 18.4513 1.27341 18.7959C1.09576 18.2289 1 17.6256 1 17C1 14.1965 2.9227 11.8422 5.5214 11.1836C5.51109 11.0384 5.50588 10.8926 5.50588 10.7462C5.50588 9.0679 6.19008 7.45837 7.40796 6.27165C8.62585 5.08493 10.2777 4.41824 12 4.41824C13.7223 4.41824 15.3741 5.08493 16.592 6.27165C17.8099 7.45837 18.4941 9.0679 18.4941 10.7462C18.4941 12.4244 17.8099 14.034 16.592 15.2207C15.6124 16.1752 14.352 16.7934 13 16.9987V17C13 17.7013 12.8797 18.3744 12.6586 19H21.7814C23.0105 19 24 18.0358 24 16.8382V4.6536C24 3.45601 23.0105 2.49234 21.7814 2.49234H16.5177V0.917086C16.5177 0.409024 16.0979 0 15.5765 0Z"
        fill="white"
      />
      <path
        d="M6.92431 11.0005C6.9495 11.0002 6.97473 11 7 11C9.8423 11 12.223 12.9764 12.8428 15.6298C13.8781 15.4602 14.8416 14.9807 15.5937 14.2479C16.5468 13.3191 17.0823 12.0595 17.0823 10.7461C17.0823 9.43263 16.5468 8.173 15.5937 7.24426C14.6406 6.31553 13.3479 5.79376 12 5.79376C10.652 5.79376 9.35931 6.31553 8.40619 7.24426C7.45306 8.173 6.9176 9.43263 6.9176 10.7461C6.9176 10.8311 6.91985 10.9159 6.92431 11.0005Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 24C3.134 24 0 20.866 0 17C0 13.134 3.134 10 7 10C10.866 10 14 13.134 14 17C14 20.866 10.866 24 7 24ZM7 23C3.68629 23 1 20.3137 1 17C1 13.6863 3.68629 11 7 11C10.3137 11 13 13.6863 13 17C13 20.3137 10.3137 23 7 23Z"
        fill="white"
      />
      <path
        d="M5.65594 18.66C5.33967 18.1847 5.15541 17.6139 5.15541 17C5.15541 16.3861 5.33967 15.8153 5.65594 15.34V14.3756C5.65594 14.0397 5.24978 13.8757 5.01546 14.11L2.39104 16.7344C2.24576 16.8813 2.24576 17.1187 2.39104 17.2656L5.01546 19.89C5.24978 20.1243 5.65594 19.9603 5.65594 19.6244V18.66Z"
        fill="white"
      />
      <path
        d="M8.65594 14C10.3132 14 11.6559 15.3427 11.6559 17C11.6559 18.6573 10.3132 20 8.65594 20C6.99868 20 5.65594 18.6573 5.65594 17C5.65594 15.3427 6.99868 14 8.65594 14ZM7.96522 18.2351L9.03215 17.4597C9.06965 17.4319 9.09142 17.3883 9.09142 17.3423V15.3065C9.09142 15.2266 9.0261 15.1613 8.94626 15.1613H8.36562C8.28578 15.1613 8.22046 15.2266 8.22046 15.3065V16.9722L7.45231 17.531C7.38699 17.5782 7.37368 17.6689 7.42086 17.7343L7.76199 18.2036C7.80917 18.2677 7.89989 18.2823 7.96522 18.2351Z"
        fill="white"
      />
    </svg>
  );
}

export default SvgImagingHistory;
